import { isEmpty } from "lodash";
import { Delegate, DelegateRole } from "types";

const delegateHasPermission = (delegate: Delegate, roles: Set<DelegateRole>) => {
    return delegate.permissions?.some((permission) => {
        return roles.has(permission.name);
    });
};

export const filterDelegates = (delegates: Delegate[], roles: Set<DelegateRole>) => {
    if (isEmpty(delegates)) {
        return [];
    }

    return delegates.filter((delegate) => delegateHasPermission(delegate, roles)) ?? [];
};
